import './CommentAuthor.scss';
import { ConfirmDeleteIcon } from '@ui/modals';
import { convertISODateToHumanReadableDate } from '@sonar-software/sonar-ts-lib';
import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import { SonarText } from '@ui/text';
import { useCurrentUser } from '@hooks';
import { UserNameDisplay } from '@ui/general';
import { Divider, Space } from 'antd';
export const CommentAuthor = ({ authorUserId, commentId, createDate, isCurrentUser, onDelete, onEdit }) => {
    const { id } = useCurrentUser();
    const date = createDate ? convertISODateToHumanReadableDate(createDate) : '';
    const hasAction = onDelete || onEdit;
    return (React.createElement(Space, null,
        React.createElement(SonarText, { weight: 'semibold' },
            React.createElement(UserNameDisplay, { userId: isCurrentUser ? id : authorUserId !== null && authorUserId !== void 0 ? authorUserId : 0 })),
        date &&
            React.createElement(SonarText, { size: 12, type: 'secondary' }, date),
        id === authorUserId && hasAction &&
            React.createElement("div", { className: 'comment-actions' },
                onEdit &&
                    React.createElement(EditOutlined, { className: 'edit-button', id: `edit-comment-${commentId}`, onClick: onEdit }),
                onDelete && onEdit && React.createElement(Divider, { type: 'vertical' }),
                onDelete && React.createElement(ConfirmDeleteIcon, { id: `delete-comment-${commentId}`, onConfirm: onDelete }))));
};
